// extracted by mini-css-extract-plugin
export var actionContainer = "ActionComplex-module--action-container--feedd";
export var actionSubheaderContainer = "ActionComplex-module--action-subheader-container--60371";
export var actionText = "ActionComplex-module--action-text--9a6ac";
export var contentContainer = "ActionComplex-module--content-container--ff2a1";
export var hasSubheader = "ActionComplex-module--has-subheader--13dd3";
export var header = "ActionComplex-module--header--5cc6e";
export var iconContainer = "ActionComplex-module--icon-container--801f6";
export var noSubheader = "ActionComplex-module--no-subheader--60172";
export var secondaryContainer = "ActionComplex-module--secondary-container--9ce1d";
export var secondaryText = "ActionComplex-module--secondary-text--e4057";